class VariantUpsellSelectors2 extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.initColorUnavailable();
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.updateForm();
    this.setColorUnavailable();

    if (this.currentVariant !== null && this.currentVariant !== undefined) {
      this.renderProductInfos();
    }
  }
  
  initColorUnavailable() {
    this.updateOptions();
    this.updateMasterId();
    this.setColorUnavailable();
  }

  updateOptions() {

    // Options with selects
    let allSelectsOptions = [];
    const allSelects = this.querySelectorAll('select');
    if (allSelects.length > 0) {
      allSelectsOptions = Array.from(
        allSelects,
        (select) => select.value,
      );
    }

    // Options with fieldset
    let allFieldsetsOptions = [];
    const allFieldsets = this.querySelectorAll('fieldset');
    if (allFieldsets.length > 0) {
      const fieldsets = Array.from(allFieldsets);
      allFieldsetsOptions = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }
    
    // Concat options
    this.options = allSelectsOptions.concat(allFieldsetsOptions);

  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  updateForm() {

    const productForm = document.getElementById(`ProductForm-${this.dataset.section}`);
    if (productForm !== null && productForm !== undefined) {

      // Update form variant id
      if (this.currentVariant) {
        const inputVariantId = productForm.querySelector('input[name="id"]');
        if (inputVariantId !== null && inputVariantId !== undefined) {
          inputVariantId.value = this.currentVariant.id;
        }
      }

      // Update form button
      const addButton = productForm.querySelector('button[name="add"]');
      if (addButton !== null && addButton !== undefined) {
        if (this.currentVariant && this.currentVariant.available) {

          addButton.innerText = window.variantStrings.upsellAddToCart;
          addButton.removeAttribute('disabled');

        } else if (this.currentVariant && this.currentVariant.available == false) {

          addButton.innerText = window.variantStrings.soldOut;
          addButton.setAttribute('disabled', 'disabled');
          
        } else {

          addButton.innerText = window.variantStrings.unavailable;
          addButton.setAttribute('disabled', 'disabled');

        }
      }
      
    }

  }

  renderProductInfos() {

    const this_section_id = this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}`,
    )
    .then((response) => response.text())
    .then((responseText) => {
      
      const this_section = document.getElementById(this_section_id);

      if (this_section !== null && this_section !== undefined) {

        const html = new DOMParser().parseFromString(
          responseText,
          'text/html',
        );

        // Prices
        const this_prices = this_section.querySelector('[data-upsell-2-product-prices]');
        const source_prices = html.querySelector('#data-for-variant-upsell-2 [data-upsell-2-product-prices]');
        if (this_prices !== null && this_prices !== undefined && source_prices !== null && source_prices !== undefined) {
          this_prices.innerHTML = source_prices.innerHTML;
        }

        // Image
        const this_image = this_section.querySelector('[data-upsell-2-product-image]');
        const source_image = html.querySelector('#data-for-variant-upsell-2 [data-upsell-2-product-image]');
        if (this_image !== null && this_image !== undefined && source_image !== null && source_image !== undefined) {
          this_image.innerHTML = source_image.innerHTML;
        }

        // Badge
        const this_badge = this_section.querySelector('[data-upsell-2-product-badge]');
        const source_badge = html.querySelector('#data-for-variant-upsell-2 [data-upsell-2-product-badge]');
        if (this_badge !== null && this_badge !== undefined && source_badge !== null && source_badge !== undefined) {
          this_badge.innerHTML = source_badge.innerHTML;
        }

        // Club discount
        const this_club_discount = this_section.querySelector('[data-upsell-2-product-club-discount] input[name="properties[_club_discount_percent]"]');
        const source_club_discount = html.querySelector('#data-for-variant-upsell-2 [data-upsell-2-product-club-discount] input[name="properties[_club_discount_percent]"]');
        if (this_club_discount !== null && this_club_discount !== undefined && source_club_discount !== null && source_club_discount !== undefined) {
          this_club_discount.value = source_club_discount.value;
        }

        // Club discounted price
        const this_club_discounted_price = this_section.querySelector('[data-upsell-2-product-club-discount]  input[name="properties[_club_discounted_price]"]');
        const source_club_discounted_price = html.querySelector('#data-for-variant-upsell-2 [data-upsell-2-product-club-discount] input[name="properties[_club_discounted_price]"]');
        if (this_club_discounted_price !== null && this_club_discounted_price !== undefined && source_club_discounted_price !== null && source_club_discounted_price !== undefined) {
          this_club_discounted_price.value = source_club_discounted_price.value;
        }

      }

    });

  }

  setColorUnavailable() {

    const colorOptions = this.querySelectorAll('.product-color-options input[type="radio"]');
    const othersOptions = this.querySelectorAll('.product-other-options');

    const colorUnavailableTexts = this.querySelectorAll('[data-color-unavailable-text]');
    let showColorUnavailableText = false;

    if (colorOptions.length > 0) {

      colorOptions.forEach(colorOption => {

        let optionsValue = [];

        if (othersOptions.length > 0) {

          othersOptions.forEach(otherOptions => {

            // Check if type is select or fieldset
            let selectedOption = otherOptions.querySelector('input:checked');
            if (selectedOption !== null && selectedOption !== undefined) {
              optionsValue.push(selectedOption.value);
            } else {
              selectedOption = otherOptions.querySelector('select');
              if (selectedOption !== null && selectedOption !== undefined) {
                optionsValue.push(selectedOption.value);
              }
            }
            
          });
          
        }

        optionsValue.push(colorOption.value);

        const variantMatch = this.getVariantData().find((variant) => {
          return !variant.options
            .map((option, index) => {
              return optionsValue[index] === option;
            })
            .includes(false);
        });

        if (variantMatch !== null && variantMatch !== undefined && variantMatch.available) {
          // Remove unavailable
          colorOption.classList.remove('unavailable');
        } else {
          // Add unavailable
          colorOption.classList.add('unavailable');
          // show/hide text unavailable color if is current option
          if (colorOption.checked) {
            showColorUnavailableText = true;
          }
        }
        
      });

      // show/hide text unavailable color if is current option
      if (colorUnavailableTexts.length > 0) {
        colorUnavailableTexts.forEach(colorUnavailableText => {
          if (showColorUnavailableText) {
            colorUnavailableText.classList.add('active');
          } else {
            colorUnavailableText.classList.remove('active');
          }
        });
      }
      
    }

  }
}

customElements.define('variant-upsell-selectors-2', VariantUpsellSelectors2);

